import Axios from 'axios';
import { API_URL } from '../../../lib/const';

const fetchEmailBatches = () => (
  Axios.get(`${API_URL}/tasks/email-batches`)
    .then(response => response.data)
);

export default fetchEmailBatches;
